"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const BankAttributes_1 = tslib_1.__importDefault(require("../BankAttributes"));
const useBank_1 = tslib_1.__importDefault(require("../../hooks/useBank"));
const Bank = (props) => {
    const bankHook = (0, useBank_1.default)({ closeBankSideBar: props.closeBankSideBar });
    return ((0, jsx_runtime_1.jsx)(BankAttributes_1.default, { setBankSideBar: props.setBankSideBar, permissions: props.permissions, hook: bankHook }));
};
exports.default = Bank;
